export default {
  zh: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`1.During Ramadan , gifts sent by users on broadcast will be recorded and tallied in this list.<br/><br/>
    2.Gifts sent by users with multiple messages will be combined and counted.<br/><br/>
    3.After the event, the top 10 users will receive rewards.`,
    sesmsg:"The operation was successful",
    rewards:"Rewards",
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
    rule: 'القواعد',
    timeR: 'العد التنازلي',
    days: 'أيام',
    ranking:"التصنيف",
    rewards:"جوائز",
    rulesDeil:`
    <br/><br/>1.  بخصوص مكافئات صناديق الشحن :<br/>
    - فقط من خلال إعادة شحن الكونز  والمبلغ المحدد يمكن للمستخدم الحصول على المكافأة المقابلة<br/>
    - يمكن تحديد اختيار واحد فقط من المكافئتين .<br/>
    - لا يتم فتح الصندوق عن طريق إعادة شحن الياقوت.<br/>
    2. عندما يتلقى المستخدم مكافآت إعادة الشحن عدة مرات، سيتم تجميع عدد مرات استلام المكافآت .  لن يتم الحصول على المكافآت التي لم يتم الحصول عليها بعد الحدث.<br/>
    3. يتم ترتيب قائمة ترتيب الهدايا من الأعلى إلى الأدنى وفقًا لقيمة الهدايا المحددة المرسلة من قبل المستخدمين.  بعد الحدث، سيحصل أفضل ثلاثة مستخدمين على مكافآت.<br/><br/>
    4. من أجل فتح صناديق العيد، يجب إعادة شحن المبلغ الكامل (لا يتم حساب المبلغ التراكمي)
    `,
    sesmsg:"العملية كانت ناجحه",
    rewards:"جوائز",
    rechargeRewards:"هدايا الشحن",
    rechargeRanking:"جوائز التصنيف",
    rechOne:"شحن $50",
    rechTwo:"شحن $100",
    rechThree:"شحن $200",
    rechargeTips:"تواصل مع خدمة العملاء للشحن",
    getText:"استلام",
    giftText:"هدية",
    modeAit:"عروض الشحن",
    giftranktip:"ارسل الهدايا التالية للانضمام للتصنيف ",
    moAct:"انقر لعرض المزيد من العروض",
    wantTo:"تواصل مع خدمة العملاء للشحن",
    newTtile:"إعادة شحن الكونزات ",
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`
    1. About box recharge : <br/>
- Only by recharging coins and the specified amount can the user obtain the corresponding reward<br/>
- Only one of the two rewards can be selected.<br/>
- the box is not opened by recharging rubies.<br/><br/>
2. When a user receives recharge rewards multiple times, the number of times the rewards are received will be accumulated. Rewards that have not been obtained after the event will not be obtained.<br/><br/>
3. The gift ranking list is sorted from high to low according to the value of the specific gifts sent by users. After the event, the top three users will receive rewards.<br/><br/>
4. in order to open Eid boxes, the full amount must be recharged ( the cumulative amount is not calculated ) 
`,
    sesmsg:"The operation was successful",
    rewards:"Rewards",
    rechargeRewards:"Recharge rewards",
    rechargeRanking:"Ranking",
    rechOne:"Recharge$50",
    rechTwo:"Recharge$100",
    rechThree:"Recharge$200",
    rechargeTips:"If you need to recharge, please contact customer service.",
    getText:"Get",
    giftText:"Gift",
    modeAit:"Recharge activities",
    giftranktip:"Join rank by send these gifts:",
    moAct:"Click to view more activities",
    wantTo:"Contact customer service to recharge",
    newTtile:"Gold coin recharge",
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    rule: 'Kural',
    timeR: 'Kalan süre: ',
    days: 'gün',
    ranking:"Sıralama",
    rewards:"Çekim Ödülleri",
    rulesDeil:`
    1. Çekim Ödülleri hakkında:<br/>
- Kullanıcı yalnızca Altın ile belirtilen miktarı yeniden çekim yaparak  ilgili ödülü alabilir<br/>
- İki ödülden yalnızca biri seçilebilir.<br/>
- Kutu yakutları yeniden çekim yaparak açılmaz.<br/>
2. Bir kullanıcı Çekim  ödüllerini birden çok kez aldığında, ödüllerin alınma sayısı toplanacaktır. Etkinlik sonrasında kazanılmayan ödüller alınamayacaktır.<br/><br/>
3. Hediye sıralama listesi, kullanıcılar tarafından gönderilen belirli hediyelerin değerine göre yüksekten düşüğe doğru sıralanır. Etkinlik sonrasında ilk üçe giren kullanıcılara belirtilen ödüller verilecektir.<br/><br/>
4. Ramazan Bayramı Etkinliğindeki Çekim kutularını açmak için,Kutuların üzerindeki miktarı Tek seferde çekim yapmalısınız. (kümülatif yani  miktarlar toplanarak hesaplanmaz)`,
    sesmsg:"İşlem Başarılı Oldu",
    rewards:"Ödüller",
    rechargeRewards:"Çekim Ödülleri",
    rechargeRanking:"Çekim Sıralaması",
    rechOne:"Çekim50$",
    rechTwo:"Çekim100$",
    rechThree:"Çekim200$",
    rechargeTips:"Çekim yapmanız  gerekiyorsa lütfen müşteri hizmetlerine başvurun.",
    getText:"Al",
    giftText:"Hediye",
    modeAit:"Çekim Aktiviteleri",
    giftranktip:"Bu hediyeleri göndererek sıralamaya katılın",
    moAct:"Daha fazla aktiviteyi görmek için tıklayın",
    wantTo:"Çekim yapmak için müşteri hizmetleriyle iletişime geçin",
    newTtile:"Altın Çekimi",
  },
    pu:{
    "topLovers": "Principais Amantes",
    "treeOfLovers": "Árvore dos Amantes",
    "rule": "Regras",
    "timeR": "Contagem regressiva: ",
    "days": "dias",
    "ranking": "Classificação",
    "rewards": "Recompensas",
    "rulesDeil": `
    1. Sobre a recarga da caixa: <br/>
- Somente ao recarregar moedas e o valor especificado o usuário poderá obter a recompensa correspondente.<br/>
- Apenas uma das duas recompensas pode ser selecionada.<br/>
- A caixa não é aberta ao recarregar rubis.<br/><br/>
2. Quando um usuário recebe recompensas de recarga várias vezes, o número de vezes que as recompensas são recebidas será acumulado. Recompensas não obtidas após o evento não poderão ser adquiridas.<br/><br/>
3. A lista de classificação de presentes é ordenada de maior para menor de acordo com o valor dos presentes específicos enviados pelos usuários. Após o evento, os três primeiros usuários receberão recompensas.<br/><br/>
4. Para abrir as caixas do Eid, o valor total deve ser recarregado (o valor acumulado não é calculado).
`,
    "sesmsg": "A operação foi bem-sucedida",
    "rechargeRewards": "Recompensas de recarga",
    "rechargeRanking": "Classificação",
    "rechOne": "Recarregar $50",
    "rechTwo": "Recarregar $100",
    "rechThree": "Recarregar $200",
    "rechargeTips": "Se precisar recarregar, entre em contato com o atendimento ao cliente.",
    "getText": "Obter",
    "giftText": "Presente",
    "modeAit": "Atividades de recarga",
    "giftranktip": "Entre na classificação enviando esses presentes:",
    "moAct": "Clique para ver mais atividades",
    "wantTo": "Entre em contato com o atendimento ao cliente para recarregar",
    "newTtile": "Recarga de moedas de ouro"
},
    id:{
    "topLovers": "Pecinta Teratas",
    "treeOfLovers": "Pohon Pecinta",
    "rule": "Aturan",
    "timeR": "Hitung mundur: ",
    "days": "hari",
    "ranking": "Peringkat",
    "rewards": "Hadiah",
    "rulesDeil": `
    1. Tentang pengisian kotak: <br/>
- Hanya dengan mengisi ulang koin dan jumlah yang ditentukan, pengguna dapat memperoleh hadiah yang sesuai.<br/>
- Hanya satu dari dua hadiah yang dapat dipilih.<br/>
- Kotak tidak dapat dibuka dengan mengisi ulang rubi.<br/><br/>
2. Ketika pengguna menerima hadiah isi ulang beberapa kali, jumlah hadiah yang diterima akan terakumulasi. Hadiah yang tidak diperoleh setelah acara tidak dapat diklaim.<br/><br/>
3. Peringkat hadiah diurutkan dari tinggi ke rendah berdasarkan nilai hadiah tertentu yang dikirim oleh pengguna. Setelah acara, tiga pengguna teratas akan menerima hadiah.<br/><br/>
4. Untuk membuka kotak Eid, jumlah penuh harus diisi ulang (jumlah kumulatif tidak dihitung).
`,
    "sesmsg": "Operasi berhasil",
    "rechargeRewards": "Hadiah isi ulang",
    "rechargeRanking": "Peringkat",
    "rechOne": "Isi ulang $50",
    "rechTwo": "Isi ulang $100",
    "rechThree": "Isi ulang $200",
    "rechargeTips": "Jika Anda perlu mengisi ulang, silakan hubungi layanan pelanggan.",
    "getText": "Dapatkan",
    "giftText": "Hadiah",
    "modeAit": "Kegiatan isi ulang",
    "giftranktip": "Bergabung dengan peringkat dengan mengirim hadiah ini:",
    "moAct": "Klik untuk melihat lebih banyak kegiatan",
    "wantTo": "Hubungi layanan pelanggan untuk mengisi ulang",
    "newTtile": "Isi ulang koin emas"
},
    uz:{
    "topLovers": "Eng Yaxshi Sevishganlar",
    "treeOfLovers": "Sevgi Daraxti",
    "rule": "Qoidalar",
    "timeR": "Orqaga sanash: ",
    "days": "kun",
    "ranking": "Reyting",
    "rewards": "Mukofotlar",
    "rulesDeil": `
    1. Quti toʻldirish haqida: <br/>
- Foydalanuvchi faqat tanga va belgilangan miqdorda toʻldirish orqali tegishli mukofotni olishi mumkin.<br/>
- Ikki mukofotdan faqat bittasi tanlanishi mumkin.<br/>
- Quti rubinlar bilan toʻldirish orqali ochilmaydi.<br/><br/>
2. Foydalanuvchi bir necha marta toʻldirish mukofotlarini olganda, qabul qilingan mukofotlar soni yigʻiladi. Tadbirdan keyin olinmagan mukofotlar berilmaydi.<br/><br/>
3. Sovg'a reytingi foydalanuvchilar tomonidan yuborilgan maxsus sovg'alar qiymatiga qarab yuqoridan pastga qarab tartiblanadi. Tadbirdan so‘ng, eng yaxshi uchta foydalanuvchi mukofot oladi.<br/><br/>
4. Eid qutilarini ochish uchun to'liq miqdor to'ldirilishi kerak (jami miqdor hisobga olinmaydi).
`,
    "sesmsg": "Amal muvaffaqiyatli bajarildi",
    "rechargeRewards": "Toʻldirish mukofotlari",
    "rechargeRanking": "Reyting",
    "rechOne": "Toʻldirish $50",
    "rechTwo": "Toʻldirish $100",
    "rechThree": "Toʻldirish $200",
    "rechargeTips": "Agar siz to'ldirishga muhtoj bo'lsangiz, mijozlarga xizmat ko'rsatish markaziga murojaat qiling.",
    "getText": "Olish",
    "giftText": "Sovgʻa",
    "modeAit": "Toʻldirish tadbirlari",
    "giftranktip": "Ushbu sovg'alarni yuborib reytingga qo'shiling:",
    "moAct": "Ko'proq tadbirlarni ko'rish uchun bosing",
    "wantTo": "To'ldirish uchun mijozlarga xizmat ko'rsatish markaziga murojaat qiling",
    "newTtile": "Oltin tanga toʻldirish"
},
    ru:{
    "topLovers": "Лучшие влюблённые",
    "treeOfLovers": "Древо любви",
    "rule": "Правила",
    "timeR": "Обратный отсчет: ",
    "days": "дней",
    "ranking": "Рейтинг",
    "rewards": "Награды",
    "rulesDeil": `
    1. О пополнении ящика: <br/>
- Только пополняя монеты на указанную сумму, пользователь может получить соответствующую награду.<br/>
- Можно выбрать только одну из двух наград.<br/>
- Ящик нельзя открыть, пополняя рубины.<br/><br/>
2. Если пользователь получает награды за пополнение несколько раз, количество полученных наград суммируется. Награды, не полученные после окончания события, аннулируются.<br/><br/>
3. Рейтинг подарков сортируется по убыванию в зависимости от стоимости отправленных пользователями специальных подарков. После окончания события трое лучших пользователей получат награды.<br/><br/>
4. Для открытия праздничных ящиков необходимо пополнить полную сумму (накопительная сумма не учитывается).
`,
    "sesmsg": "Операция успешно выполнена",
    "rechargeRewards": "Награды за пополнение",
    "rechargeRanking": "Рейтинг",
    "rechOne": "Пополнение $50",
    "rechTwo": "Пополнение $100",
    "rechThree": "Пополнение $200",
    "rechargeTips": "Если вам нужно пополнить счет, свяжитесь со службой поддержки.",
    "getText": "Получить",
    "giftText": "Подарок",
    "modeAit": "Акции по пополнению",
    "giftranktip": "Присоединяйтесь к рейтингу, отправляя эти подарки:",
    "moAct": "Нажмите, чтобы увидеть больше событий",
    "wantTo": "Свяжитесь со службой поддержки для пополнения",
    "newTtile": "Пополнение золотых монет"
},
    fa:{
    "topLovers": "برترین عاشقان",
    "treeOfLovers": "درخت عاشقان",
    "rule": "قوانین",
    "timeR": "شمارش معکوس: ",
    "days": "روز",
    "ranking": "رتبه‌بندی",
    "rewards": "جوایز",
    "rulesDeil": `
    1. درباره شارژ جعبه: <br/>
- فقط با شارژ سکه‌ها به مقدار مشخص، کاربر می‌تواند پاداش مربوطه را دریافت کند.<br/>
- فقط یکی از دو پاداش را می‌توان انتخاب کرد.<br/>
- جعبه با شارژ یاقوت باز نمی‌شود.<br/><br/>
2. هنگامی که کاربر چندین بار پاداش شارژ دریافت می‌کند، تعداد دفعات دریافت پاداش‌ها جمع می‌شود. پاداش‌هایی که پس از رویداد دریافت نشده‌اند، از بین خواهند رفت.<br/><br/>
3. لیست رتبه‌بندی هدایا بر اساس ارزش هدایای خاص ارسال‌شده توسط کاربران از زیاد به کم مرتب می‌شود. پس از پایان رویداد، سه کاربر برتر جوایز دریافت خواهند کرد.<br/><br/>
4. برای باز کردن جعبه‌های عید، باید مبلغ کامل شارژ شود (مقدار تجمعی محاسبه نمی‌شود).
`,
    "sesmsg": "عملیات با موفقیت انجام شد",
    "rechargeRewards": "جوایز شارژ",
    "rechargeRanking": "رتبه‌بندی",
    "rechOne": "شارژ $50",
    "rechTwo": "شارژ $100",
    "rechThree": "شارژ $200",
    "rechargeTips": "اگر نیاز به شارژ دارید، لطفاً با خدمات مشتری تماس بگیرید.",
    "getText": "دریافت",
    "giftText": "هدیه",
    "modeAit": "فعالیت‌های شارژ",
    "giftranktip": "برای پیوستن به رتبه‌بندی، این هدایا را ارسال کنید:",
    "moAct": "برای مشاهده رویدادهای بیشتر کلیک کنید",
    "wantTo": "برای شارژ با خدمات مشتری تماس بگیرید",
    "newTtile": "شارژ سکه‌های طلا"
}





}



// WEBPACK FOOTER //
// src/pages/activity/allGamRank/lang.js